import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueLazyLoad from 'vue-lazyload'

import ElementUI from 'element-ui'
import Content from './components/share/Content'
import CloudCard from './components/share/CloudCard'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/theme/index.css'
import './assets/style/index.less'
import './assets/style/el.less'
import store from './store'
import routes from './routes'
import '../src/assets/script/statistics/statistics.js'

Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.config.productionTip = false;
const router = new VueRouter({
  mode: 'history',
  routes
});






router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    window.wechart = {
      code: to.query["code"],
      state: to.query["state"],
    };
    router.replace("/")
  }
  else if (to.path.indexOf('yuliao') > -1 || to.path.indexOf('naotu') > -1) {
    if (to.query["code"]) {
      window.wechart = {
        code: to.query["code"]
      };
      router.replace(to.path);
    }
  }
  else if (to.query["code"]) {
    //其他页面
    window.wechart = {
      code: to.query["code"]
    };
    router.replace(to.path);
  }

  next()
});
Vue.component("Content", Content);
Vue.component("CloudCard", CloudCard);


Vue.prototype.$copy = function (value) {
  let textarea = document.createElement("textarea");
  textarea.style.position = 'fixed';
  textarea.style.top = "0";
  textarea.style.left = "0";
  textarea.style.border = 'none';
  textarea.style.outline = 'none';
  textarea.style.resize = 'none';
  textarea.style.background = 'transparent';
  textarea.style.color = 'transparent';
  textarea.value = value;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea)
};

Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  attempt: 1
});

window.app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
